export class IntegrationNotFoundError extends Error {}
